import { Pipe, PipeTransform } from '@angular/core';

import * as moment from 'moment';

@Pipe({
  name: 'momentFormat',
})
export class MomentFormatPipe implements PipeTransform {
  transform(value: number | string, formatString: string): any {
    const output: any = moment(value).format(formatString);

    return output;
  }
}
